export const EVENT_NAME = "PROFINEXPO BANGKOK 2026";
export const EVENT_DATES = "TBA";
export const EVENT_DAYS = "Schedule";
export const EVENT_DAY_ONE_DATE = "TBA";
export const EVENT_DAY_TWO_DATE = "TBA";
export const EVENT_DAY_ONE_DATE_SHORT = "TBA";
export const EVENT_DAY_TWO_DATE_SHORT = "TBA";
export const EVENT_DAY_ONE_DATE_ISO = "";
export const EVENT_DAY_TWO_DATE_ISO = "";
export const EVENT_VENUE = "Ambassador TBA";
export const EVENT_LOCATION = "Ambassador TBA";
export const EVENT_ADDRESS =
  "TBA";
export const EVENT_MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=Ambassador+TBA";
export const EVENT_MAP_EMBED_URL =
  "https://www.google.com/maps?q=Ambassador+TBA&output=embed";
export const EVENT_COUNTDOWN_TARGET = "";
